import { GET_KEY_TYPES_SUCCESS } from "../actionTypes";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_KEY_TYPES_SUCCESS: {
      const keyTypes = action.payload;

      if (!keyTypes){
        return [...state];
      }

      return [
        ...state,
        ...keyTypes
      ]
    }
    default:
      return state;
  }
}
